var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fill: "#9A660A", d: "M5 2h5v9H5z" }),
    React.createElement("path", { d: "M7.138 14C3.251 14 .096 10.864.096 7s3.155-7 7.042-7 7.042 3.136 7.042 7-3.155 7-7.042 7zm0-6.176a.743.743 0 0 0 .746-.742V4.035a.743.743 0 0 0-.746-.74.743.743 0 0 0-.745.74v3.047c0 .41.333.742.745.742zm0 2.882a.826.826 0 0 0 .829-.824.826.826 0 0 0-.829-.823.826.826 0 0 0-.828.823c0 .455.37.824.828.824z", fill: "#FFDB19" })
  );
});